/**
 * Checks if the given value is an array.
 */
export const isArray = (input: unknown) => Array.isArray(input)
